import {Button} from "react-bootstrap";
import {FaPlayCircle} from "react-icons/fa";
import React from "react";
import {VideoModel} from "../../../models/domain/videoModel";

interface IProps {
    model: VideoModel
    onClick: () => void
}

export const PlayButton = ({model: {filename, title, description, thumbnailUrl}, onClick}: IProps) => {
    return (
        <>
            <Button tabIndex={0}
                    title="Play Video"
                    aria-label="Play Video"
                    variant="link"
                    className="play-button position-absolute top-50 start-50 translate-middle"
                    onClick={onClick}>
                <FaPlayCircle aria-hidden="true"
                              size={150}
                              className="text-primary"/>
                <div className="bg-white position-absolute top-50 start-50 translate-middle"
                     style={{height: '100px', width: '100px', zIndex: '-1'}}/>
            </Button>
            {/* <div className="position-absolute top-0 start-0 fs-5">
                {description}
            </div> */}
            <img src={thumbnailUrl}
                 alt={filename}
                 title={title}
                 className="poster-image d-block img-fluid"
                 height={360}
                 width={640}
                 loading="lazy" decoding="async"
                 aria-hidden/>
        </>
    );
}